import { render, staticRenderFns } from "./readIndex.vue?vue&type=template&id=73263aea&scoped=true&"
import script from "./readIndex.vue?vue&type=script&lang=js&"
export * from "./readIndex.vue?vue&type=script&lang=js&"
import style0 from "./readIndex.vue?vue&type=style&index=0&id=73263aea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73263aea",
  null
  
)

export default component.exports